// extracted by mini-css-extract-plugin
export default {"image":"BW-z","loaded":"CW-z"};